import { useRef } from "react";
import { useViewport } from "../../../../hooks/useViewport";
import { TableFooterClock } from "./TableFooterClock";
import { RailResizeHandle } from "./layout/RailResizeHandle";
import { DETAILS_MIN_WIDTH, useTablesLayout } from "./layout/tablesLayout";

interface TableRailProps {
  /** Скрита релса — на тесен екран след двоен клик върху маса. */
  hidden: boolean;
  children: React.ReactNode;
}

/**
 * Релсата с маси вляво: списъкът (скролва се сам в `TableList`) и под него
 * часовникът — само на десктоп. Часовникът е тук, а не в лентата под масите,
 * за да остане цялата лента за бутоните (и за изнесените от „Опции").
 * Височината на реда съвпада с реда на „Обобщено" вдясно (`OrderDetails`).
 * На десктоп ширината се тегли с дръжката на десния ръб (`RailResizeHandle`).
 */
export const TableRail = ({ hidden, children }: TableRailProps) => {
  const { isDesktop } = useViewport();
  const railWidth = useTablesLayout((layout) => layout.railWidth);
  const railRef = useRef<HTMLElement>(null);
  const customWidth = isDesktop && railWidth !== null;
  return (
    <aside
      ref={railRef}
      // Избраната ширина е известна чак по време на работа → inline; таван —
      // дясната част да остане поне DETAILS_MIN_WIDTH и при по-малък прозорец.
      style={customWidth ? { width: `min(${railWidth}px, calc(100% - ${DETAILS_MIN_WIDTH}px))` } : undefined}
      className={`relative flex flex-col flex-shrink-0 bg-pos-panel border-r border-pos-line ${
        customWidth ? "" : "w-[124px] sm:w-44 lg:w-[clamp(340px,26%,470px)]"
      } ${hidden ? "hidden" : ""}`}
    >
      <div className="flex-1 min-h-0 overflow-y-auto">{children}</div>
      {isDesktop && (
        <div className="shrink-0 flex h-12 items-center px-5">
          <TableFooterClock />
        </div>
      )}
      {isDesktop && <RailResizeHandle railRef={railRef} />}
    </aside>
  );
};
